import React, { useState } from 'react';
import { Box, TextField, Button, Typography, CircularProgress, Grid } from '@mui/material';
import participantsApi from '../../../services/api/participants/participantsApi';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { iconEmail } from '../../assets/images';

const EmailLoginForm = ({ onBackClick }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await participantsApi.sendLoginEmail(email);
      if (response === true) {
        setEmailSent(true);
      } else {
        setError('Email not found. Please check and try again.');
      }
    } catch {
      setError('Unable to send login email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid item lg={6} md={6} sm={11} xs={11}>
      <div className="formHeader">
        <div className="iconContainer">
          <img src={iconEmail} alt=""/>
        </div>
        <h2 className="formTitle">Login with Email</h2>
      </div>
      {error && (
        <Typography color="error" sx={{ mb: 2 }} textAlign="center">{error}</Typography>
      )}
      {emailSent ? (
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body1" paragraph>
            Login link sent to <strong>{email}</strong>
          </Typography>
          <Button onClick={onBackClick} variant="outlined">
            Back
          </Button>
        </Box>
      ) : (
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disableRipple            
            className="formButton"
            disabled={loading}
            startIcon={loading && <CircularProgress size={20} color="inherit" />}
            disableElevation
          >
            {loading ? 'Sending...' : 'Send Login Link'}
          </Button>
          <Button fullWidth variant="text" onClick={onBackClick} className="backButton" startIcon={<KeyboardBackspaceIcon />} disableRipple>
            Back to Login Options
          </Button>
        </Box>
      )}
      </Grid>
    </Grid>
  );
};

export default EmailLoginForm;
